import { useFormikContext } from 'formik'
import { debounce } from 'lodash'
import { useEffect, useMemo } from 'react'
import { PatientHistoryEntry } from 'src/legacy/components/ParticipantRecords/ParticipantHistory/types'
import { PatientHistoryFormType } from 'src/participantHistory/constants'
import { saveFormToLocalStorage } from './persistFormHelpers'

type FormPersistorProps = { formType: PatientHistoryFormType; uid: string }

const DEBOUNCE_DELAY_MS = 300

const FormPersistor = ({ formType, uid }: FormPersistorProps) => {
  const { values, dirty, isSubmitting } = useFormikContext<PatientHistoryEntry>()

  const debouncedSave = useMemo(
    () =>
      debounce((formValues: PatientHistoryEntry) => {
        saveFormToLocalStorage(uid, formType, formValues)
      }, DEBOUNCE_DELAY_MS),
    [uid, formType]
  )

  useEffect(() => {
    if (!dirty || isSubmitting) {
      debouncedSave.cancel()
      return
    }
    debouncedSave(values)
  }, [values, dirty, isSubmitting, debouncedSave])

  useEffect(() => () => debouncedSave.cancel(), [debouncedSave])

  return null
}

export default FormPersistor
